var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"earnings-receiveds"},[_c('EarningsReceivedsFilters',{staticClass:"earnings-receiveds__filters",on:{"on-select-filter":_vm.onSelectFilter}}),_c('EarningsChart'),_c('EarningsAccordions',{staticClass:"earnings-receiveds__accordions",attrs:{"accordion-headers":_vm.accordionHeaders}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }